import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { DateMode } from "~produce/labor/schedule/helpers/types";

type PanelMode = "detail" | "workers" | null;
type ViewMode = "list" | "pivot";

export interface LaborScheduleState {
	assignDialogBulk: boolean;
	assignDialogIsDirty: boolean;
	assignDialogOpen: boolean;
	assignDialogTitle: string;
	dateMode: DateMode;
	panelMode: PanelMode;
	selectedRowIds: string[];
	selectedWorkerId: string | null;
	viewMode: ViewMode;
}

const initialState: LaborScheduleState = {
	assignDialogBulk: false,
	assignDialogIsDirty: false,
	assignDialogOpen: false,
	assignDialogTitle: "",
	dateMode: "week",
	panelMode: null,
	selectedRowIds: [],
	selectedWorkerId: null,
	viewMode: "list"
};

export const laborScheduleSlice = createSlice({
	initialState,
	name: "laborSchedule",
	reducers: {
		closeAssignDialog: (state) => {
			state.assignDialogOpen = false;
			state.assignDialogTitle = "";
			state.assignDialogBulk = false;
		},
		openAssignDialog: (state, action: PayloadAction<{ bulk: boolean; title: string }>) => {
			state.assignDialogOpen = true;
			state.assignDialogTitle = action.payload.title;
			state.assignDialogBulk = action.payload.bulk;
		},
		setAssignDialogIsDirty: (state, action: PayloadAction<boolean>) => {
			state.assignDialogIsDirty = action.payload;
		},
		setDateMode: (state, action: PayloadAction<DateMode>) => {
			state.dateMode = action.payload;
		},
		setPanelMode: (state, action: PayloadAction<PanelMode>) => {
			state.panelMode = action.payload;
		},
		setSelectedRowIds: (state, action: PayloadAction<string[]>) => {
			state.selectedRowIds = action.payload;
		},
		setSelectedWorkerId: (state, action: PayloadAction<string | null>) => {
			state.selectedWorkerId = action.payload;
		},
		setViewMode: (state, action: PayloadAction<ViewMode>) => {
			state.viewMode = action.payload;
		}
	}
});

export const {
	closeAssignDialog,
	openAssignDialog,
	setAssignDialogIsDirty,
	setDateMode,
	setPanelMode,
	setSelectedRowIds,
	setSelectedWorkerId,
	setViewMode
} = laborScheduleSlice.actions;

export default laborScheduleSlice.reducer;
